import CustomCssHandler from "./customCssHandler"
import { CustomCssHandlerProps } from "./interface"

export type { CustomCssHandlerProps }
export default CustomCssHandler
